import { render, staticRenderFns } from "./MenuResults.vue?vue&type=template&id=33b8b3f6"
import script from "./MenuResults.vue?vue&type=script&lang=ts"
export * from "./MenuResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports